import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import ScrollToTop from "react-scroll-up";
import { IntercomProvider } from "react-use-intercom";
import "./App.scss";
import { Header } from "./components/Header";
import { AcceptableUsePolicy } from "./pages/acceptable-use-policy";
import { CandidateExplainer } from "./pages/candidate-explainer";
import { CandidateExplainerPrivacyPolicy } from "./pages/candidate-explainer-privacy-policy";
import { CookiePolicy } from "./pages/cookie-policy";
import { SiPrivacyPolicy } from "./pages/si-privacy-policy";
import { SiSupport } from "./pages/si-support";
import { SiSupportAbout } from "./pages/si-support-about";
import { SiSupportHowTo } from "./pages/si-support-how-to";
import { SiSupportIssues } from "./pages/si-support-issues";
import { SiSupportMore } from "./pages/si-support-more";
import { SiTermsOfService } from "./pages/si-terms-of-service";
import { TermsOfService } from "./pages/terms-of-service";
const INTERCOM_APP_ID = "b65nv99l";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      autoBoot={true}
      autoBootProps={{ hideDefaultLauncher: true }}
    >
      <HelmetProvider>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Redirect to="/candidate-explainer" />
            </Route>

            <Route path="/candidate-explainer">
              <>
                {/* <Header></Header> */}
                <CandidateExplainer />
              </>
            </Route>

            <Route path="/candidate-explainer-privacy-policy">
              <>
                {/* <Header></Header> */}
                <CandidateExplainerPrivacyPolicy />
              </>
            </Route>

            <Route path="/si-privacy-policy">
              <>
                {/* <Header
                  title="SecondInterview by Sapia"
                  redirectDefaultUrl="/second-interview-support"
                ></Header> */}
                <SiPrivacyPolicy />
              </>
            </Route>

            <Route path="/terms-of-service">
              <>
                {/* <Header></Header> */}
                <TermsOfService />
              </>
            </Route>

            {/* TODO */}
            <Route path="/si-terms-of-service">
              <>
                <Header
                  title="SecondInterview by Sapia"
                  redirectDefaultUrl="/second-interview-support"
                ></Header>
                <SiTermsOfService />
              </>
            </Route>

            {/* TODO */}
            <Route path="/cookie-policy">
              <>
                <Header></Header>
                <CookiePolicy />
              </>
            </Route>

            {/* TODO */}
            <Route path="/acceptable-use-policy">
              <>
                <Header></Header>
                <AcceptableUsePolicy />
              </>
            </Route>

            <Route path="/second-interview-support">
              <>
                {/* <Header
                  title="SecondInterview by Sapia"
                  redirectDefaultUrl="/second-interview-support"
                /> */}
                <SiSupport></SiSupport>
              </>
            </Route>

            <Route path="/second-interview-support-about">
              <>
                {/* <Header
                  title="SecondInterview by Sapia"
                  redirectDefaultUrl="/second-interview-support"
                /> */}
                <SiSupportAbout />
              </>
            </Route>

            <Route path="/second-interview-support-how-to">
              <>
                {/* <Header
                  title="SecondInterview by Sapia"
                  redirectDefaultUrl="/second-interview-support"
                /> */}
                <SiSupportHowTo />
              </>
            </Route>

            <Route path="/second-interview-support-issues">
              <>
                {/* <Header
                  title="SecondInterview by Sapia"
                  redirectDefaultUrl="/second-interview-support"
                /> */}
                <SiSupportIssues />
              </>
            </Route>

            <Route path="/second-interview-support-more">
              <>
                {/* <Header
                  title="SecondInterview by Sapia"
                  redirectDefaultUrl="/second-interview-support"
                /> */}
                <SiSupportMore />
              </>
            </Route>
          </Switch>
        </div>
        <ScrollToTop showUnder={160}>
          <span className="scroll-up-btn"></span>
        </ScrollToTop>
      </HelmetProvider>
    </IntercomProvider>
  );
}

export default App;
